let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b96A2")).then(() => parcelRequire('6WyHk'));